import React from "react";
import { useLocation, useHistory } from "react-router-dom";

export default function UnlockShiptoUploadResult() {
  const history = useHistory();
  const { state } = useLocation();

  const failed = state?.failedData || {};

  const duplicates = failed?.duplicates || [];
  const invalid = failed?.invalid || [];
  const notFound = failed?.notFound || [];

  const anothersubscription = failed?.anothersubscription || []

  const inserted = state?.inserted || 0;

  const totalFailed = duplicates.length + invalid.length + notFound.length +anothersubscription.length;

  // ✅ backend summary fallback
  const total =
    state?.summary?.total ||
    inserted + totalFailed;

  const success =
    state?.summary?.inserted ||
    inserted;
    const exportFailedData = () => {
  const failedRecords = [
    ...duplicates.map((item) => ({
      shipTo: item.customer_account_number,
      reason: item.reason,
    })),
    ...invalid.map((item) => ({
      shipTo: item.customer_account_number,
      reason: item.reason,
    })),
    ...notFound.map((item) => ({
      shipTo: item.customer_account_number,
      reason: item.reason,
    })),
    ...anothersubscription.map((item) => ({
      shipTo: item.customer_account_number,
      reason: item.reason,
    })),
  ];

  if (failedRecords.length === 0) {
    return;
  }

  const headers = ["ShipTo", "Reason"];

  const csvRows = [
    headers.join(","),
    ...failedRecords.map((item) =>
      [
        item.shipTo,
        `"${String(item.reason || "").replace(/"/g, '""')}"`,
      ].join(",")
    ),
  ];

  const csvContent = csvRows.join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "UnlockShipTo_FailedRecords.csv");

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

  return (
    <div
      style={{
        padding: 24,
        fontFamily: "Arial",
        background: "#f6f8fb",
        minHeight: "100vh",
      }}
    >
      {/* BACK BUTTON */}
      <button
        onClick={() => history.goBack()}
        style={{
          backgroundColor: "#2f5fb3",
          color: "white",
          border: "none",
          padding: "8px 16px",
          borderRadius: 6,
          marginBottom: 20,
          cursor: "pointer",
        }}
      >
        Back
      </button>

      <h2 style={{ marginBottom: 20 }}>Upload Result Summary</h2>

      {/* ================= CARDS ================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: 15,
          marginBottom: 25,
        }}
      >
        <Card title="Total Records" value={total} color="#333" />
        <Card title="Success" value={success} color="green" />
        <Card
  title="Failed"
  value={totalFailed}
  color="red"
  sub={`Duplicates: ${duplicates.length} • Invalid: ${invalid.length} • Not Found: ${notFound.length} • Another Subscription: ${anothersubscription.length}`}
  action={
    totalFailed > 0 && (
      <button
        onClick={exportFailedData}
        style={{
          marginTop: 10,
          padding: "6px 12px",
          border: "none",
          borderRadius: 5,
          backgroundColor: "#2f5fb3",
          color: "white",
          cursor: "pointer",
          fontSize: 12,
        }}
      >
        ↓ Export
      </button>
    )
  }
/>
        <Card title="Duplicates" value={duplicates.length} color="#d9534f" />
        <Card title="Invalid" value={invalid.length} color="#f0ad4e" />
        <Card title="Not Found" value={notFound.length} color="#6c757d" />
        <Card title="Another Subscription" value={anothersubscription.length} color="#6c757d" />
      </div>

      {/* ================= DUPLICATES ================= */}
      {duplicates.length > 0 && (
        <Section title="Duplicate ShipTo (Already Exists)" color="red">
          <Table data={duplicates} />
        </Section>
      )}

      {/* ================= INVALID ================= */}
      {invalid.length > 0 && (
        <Section>
          {/* Friendly Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 10,
            }}
          >
            <span style={{ fontSize: 18 }}>⚠️</span>

            <h3
              style={{
                color: "#b58105",
                margin: 0,
                fontWeight: "600",
              }}
            >
              Invalid Records
            </h3>
          </div>

          {/* Info Box */}
          <div
            style={{
              background: "#fff8e1",
              border: "1px solid #ffe58f",
              padding: 12,
              borderRadius: 8,
              marginBottom: 12,
              fontSize: 13,
              color: "#8a6d3b",
            }}
          >
            These records were not uploaded due to incorrect format or missing
            values or invalid values. Please review and correct them before re-uploading.
          </div>

          <Table data={invalid} />
        </Section>
      )}

      {/* ================= NOT FOUND ================= */}
      {notFound.length > 0 && (
        <Section>
          {/* Friendly Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 10,
            }}
          >
            <span style={{ fontSize: 18 }}>🔍</span>

            <h3
              style={{
                color: "#6c757d",
                margin: 0,
                fontWeight: "600",
              }}
            >
              Not Found in Customer Account
            </h3>
          </div>

          {/* Info Box */}
          <div
            style={{
              background: "#f1f3f5",
              border: "1px solid #dee2e6",
              padding: 12,
              borderRadius: 8,
              marginBottom: 12,
              fontSize: 13,
              color: "#495057",
            }}
          >
            These ShipTo numbers were not found in Customer Account and were not
            uploaded. Please verify the ShipTo numbers and try again.
          </div>

          <Table data={notFound} />
        </Section>
      )}



       {anothersubscription.length > 0 && (
  <Section>
    {/* Friendly Header */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 10,
      }}
    >
      <span style={{ fontSize: 18 }}>🔄</span>

      <h3
        style={{
          color: "#6c757d",
          margin: 0,
          fontWeight: "600",
        }}
      >
       Existing Subscription Detected
      </h3>
    </div>

    {/* Info Box */}
    <div
      style={{
        background: "#f1f3f5",
        border: "1px solid #dee2e6",
        padding: 12,
        borderRadius: 8,
        marginBottom: 12,
        fontSize: 13,
        color: "#495057",
      }}
    >
      These ShipTo numbers are already enrolled in another subscription and
      were not uploaded. Please review the subscription details and try again.
    </div>

    <Table data={anothersubscription} />
  </Section>
)}

      {/* ================= MESSAGE WHEN ALL SUCCESS ================= */}
      {duplicates.length === 0 && invalid.length === 0 && notFound.length === 0 && anothersubscription.length === 0 && (
        <div
          style={{
            backgroundColor: "#dff0d8",
            borderRadius: 8,
            padding: 15,
            color: "#3c763d",
            marginTop: 25,
            textAlign: "center",
          }}
        >
          <h3>All records uploaded successfully!</h3>
        </div>
      )}
    </div>
  );
}

/* ================= CARD ================= */
const Card = ({ title, value, color, sub, action }) => (
  <div
    style={{
      background: "white",
      padding: 15,
      borderRadius: 10,
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div style={{ fontSize: 14, color: "#777" }}>{title}</div>

    <div style={{ fontSize: 22, fontWeight: "bold", color }}>
      {value}
    </div>

    {sub && (
      <div style={{ fontSize: 12, marginTop: 5, color: "#666" }}>
        {sub}
      </div>
    )}

    {action && action}
  </div>
);

/* ================= SECTION ================= */
const Section = ({ title, color, children }) => (
  <div style={{ marginBottom: 25 }}>
    {title && (
      <h3 style={{ color, marginBottom: 10 }}>{title}</h3>
    )}
    {children}
  </div>
);

/* ================= TABLE ================= */
const Table = ({ data }) => (
  <table
    style={{
      width: "100%",
      background: "white",
      borderCollapse: "collapse",
      borderRadius: 8,
      overflow: "hidden",
      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    }}
  >
    <thead style={{ background: "#f0f0f0" }}>
      <tr>
        <th style={{ textAlign: "center", padding: 10 }}>ShipTo</th>
        <th style={{ textAlign: "center", padding: 10 }}>Reason</th>
      </tr>
    </thead>

    <tbody>
      {data.map((item, i) => (
        <tr key={i}>
          <td style={{ textAlign: "center", padding: 10 }}>
            {item.customer_account_number}
          </td>

          <td style={{ textAlign: "center", padding: 10 }}>
            {item.reason}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);